"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.undefinedCheck = (value) => value ? `${value}` : "";
//# sourceMappingURL=undefined-check.js.map